import { State } from 'src/redux/reducer';
import { TitleCreateTestType } from './types';

export const titleCreateTestSelector = (state: State): TitleCreateTestType =>
  state.titleCreateTest;
